<template>
  <div>
    <div class="top">
      <Header />
      <Start />
    </div>
    <Services />
    <About />
    <Certificates />
    <Charity />
    <Contact />
    <Footer />
    <Cookie />
  </div>
</template>

<script>
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Start from "../components/Start";
import Services from "../components/Services";
import Certificates from "../components/Certificates";
import Cookie from "../components/Cookie";
import Charity from "../components/Charity";

export default {
  name: "Home",
  components: {
    About,
    Contact,
    Footer,
    Header,
    Start,
    Services,
    Certificates,
    Cookie,
    Charity,
  }
};
</script>

<style scoped>
.top {
  background-image: url('../assets/berlin_003.png');
  background-size: 100%;
  background-position: bottom;
}
@media (max-width: 600px) {
  .top {
    background-size: auto;

  }
}
</style>